var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Faq',{attrs:{"faq":_vm.faq,"buttonLoading":_vm.buttonLoading},on:{"saveFaq":_vm.saveFaq}})}
var staticRenderFns = []

export { render, staticRenderFns }